import CREApi from './_creApi';
import httpClient from '@/apis/base/httpclient';
import { FormMultiPart } from '@/apis/base/httpclient';

class CRERepListAPI extends CREApi {
  constructor() {
    super();
  }
  controllerName = 'CRERepLists';

  /**
   * Dữ liệu báo cáo
   * TPNAM 02.06.2022
   */
  getDataReport(param) {
    let request = {
      url: this.getAPIUrl() + '/FinancialReport',
      data: param,
    };

    return httpClient.postAsync(request);
  }
  /**
   * Dữ liệu báo cáo cho Lekima
   * TBNGOC 05.04.2023
   */
  getDataReportLekima(param) {
    let request = {
      url: this.getAPIUrl() + '/FinancialReportLekima',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Dữ liệu báo cáo
   * NXCHIEN 27.09.2022
   */
  deleteDataReport(param) {
    let request = {
      url: this.getAPIUrl() + '/FinancialClear',
      data: param,
    };

    return httpClient.postAsync(request);
  }
  /**
   * Kiểm tra đã nhập khẩu TKT chưa
   * TVDAT 14/10/2022
   */
  checkImportTKT(param) {
    let request = {
      url: this.getAPIUrl() + '/CheckImportTKT',
      data: param,
    };
    return httpClient.postAsync(request);
  }
  /**
   * Kiểm tra đã tồn tại BCTC chưa
   *
   */
  CheckExistCRERep(param) {
    let request = {
      url: this.getAPIUrl() + '/CheckExistCRERep',
      data: param,
    };
    return httpClient.postAsync(request);
  }
  /**
   * Kiểm tra đã tồn tại BCTC C03 chưa cho báo cáo
   *
   */
   CheckExistCRERepForReport(param) {
    let request = {
      url: this.getAPIUrl() + '/CheckExistCRERepForReport',
      data: param,
    };
    return httpClient.postAsync(request);
  }

  /**
   * Kiểm tra tồn tại B01/BCTC và B04/BCTC cùng kỳ bc C03 chưa
   * dtnag3 (28.03.2023) chuyển check BE
   */
  CheckCRERepForCheckingC03(param) {
    let request = {
      url: this.getAPIUrl() + '/CheckCRERepForCheckingC03',
      data: param,
    };
    return httpClient.postAsync(request);
  }
  /**
   * Dữ liệu báo cáo
   * dqdat1 24.05.2023
   */
  getDataPrevious(param) {
    let request = {
      url: this.getAPIUrl() + '/PreviousFinancialReport',
      data: param,
    };

    return httpClient.postAsync(request);
  }
  /**
   * Dữ liệu danh sách năm
   * dqdat1 24.05.2023
   */
  getDataYear(param) {
    let request = {
      url: this.getAPIUrl() + '/DataPrevious',
      data: param,
    };

    return httpClient.postAsync(request);
  }
  /**
   * Dữ liệu báo cáo từng tab
   * dqdat1 27.02.2024
   */
  getDataReportTab(param) {
    let request = {
      url: this.getAPIUrl() + '/CRERepListTab',
      data: param,
    };

    return httpClient.postAsync(request);
  }
  
  /**
   * Dữ liệu báo cáo C03 từ QLTS
   * dqdat1 02.04.2024
   */
  getDataReportC03QLTS(param) {
    let request = {
      url: this.getAPIUrl() + '/FinancialReportC03QLTS',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * 
   * Số dữ liệu trong đơn vị
   * DTQUOC 19.04.2024 
   */
  getCountDataUnit() {
    let request = {
      url: this.getAPIUrl() + '/GetCountDataUnit',
    };

    return httpClient.getAsync(request);
  }
}

export default new CRERepListAPI();
